export default [
  {
    path: '/console',
    component: () => import('@/pages/console/ConsoleLayout.vue'),
    children: [
      // 监测管理（激活标签页系统）
      {
        path: 'sites',
        component: () => import('@/pages/console/RouteView.vue'),
        redirect: 'sites/list',
        meta: { requiresOrgContext: true },
        children: [
          {
            path: 'list',
            name: 'SiteListPage',
            meta: { keepAlive: true, requiresOrgContext: true },
            component: () => import('@/pages/stationManagePage/stationList.vue'),
          },
          {
            path: 'data',
            name: 'SiteDataPage',
            meta: { keepAlive: true, requiresOrgContext: true },
            component: () => import('@/pages/stationManagePage/dataList.vue'),
          },
          {
            path: 'reports',
            name: 'SiteReportsPage',
            meta: { requiresOrgContext: true },
            component: () => import('@/pages/saveReportPage/reportList.vue'),
          },
          {
            path: 'report',
            name: 'SiteReportDetailPage',
            meta: { requiresOrgContext: true },
            component: () => import('@/pages/report/index.vue'),
          },
          {
            path: 'detail',
            name: 'SiteDetailPage',
            meta: { requiresOrgContext: true },
            component: () => import('@/pages/stationManagePage/stationDetail.vue'),
          },
          {
            path: 'detail/data',
            name: 'SiteDetailDataPage',
            meta: { requiresOrgContext: true },
            component: () => import('@/pages/stationManagePage/dataDetail.vue'),
          },
        ],
      },
      // 告警事件
      {
        path: 'alerts',
        component: () => import('@/pages/console/RouteView.vue'),
        redirect: 'alerts/electrical',
        meta: { requiresOrgContext: true },
        children: [
          { path: 'electrical',   name: 'AlertElectricalPage',    meta: { requiresOrgContext: true },  component: () => import('@/pages/unusualCenterPage/electricWarn.vue') },
          { path: 'environment',  name: 'AlertEnvironmentPage',   meta: { requiresOrgContext: true },  component: () => import('@/pages/unusualCenterPage/environmentWarn.vue') },
          { path: 'hazard',       name: 'AlertHazardPage',        meta: { requiresOrgContext: true },  component: () => import('@/pages/unusualCenterPage/hiddenWarn.vue') },
          { path: 'equipment',    name: 'AlertEquipmentPage',     meta: { requiresOrgContext: true },  component: () => import('@/pages/unusualCenterPage/hiddenEquipment.vue') },
        ],
      },
      // 终端设备
      {
        path: 'devices',
        component: () => import('@/pages/console/RouteView.vue'),
        redirect: 'devices/manage',
        meta: { requiresOrgContext: true },
        children: [
          { path: 'manage',  name: 'DeviceManagePage', meta: { requiresOrgContext: true }, component: () => import('@/pages/deviceCenterPage/deviceManger.vue') },
          { path: 'ops',     name: 'DeviceOpsPage',    meta: { requiresOrgContext: true }, component: () => import('@/pages/deviceCenterPage/deviceOps.vue') },
        ],
      },
      // 能耗分析
      {
        path: 'energy',
        component: () => import('@/pages/console/RouteView.vue'),
        redirect: 'energy/statistics',
        meta: { requiresOrgContext: true },
        children: [
          { path: 'overview',  name: 'EnergyOverviewPage',  meta: { requiresOrgContext: true }, component: () => import('@/pages/powerWatch/index.vue') },
          { path: 'statistics', name: 'EnergyStatisticsPage', meta: { requiresOrgContext: true }, component: () => import('@/pages/energy/statistics.vue') },
          { path: 'carbon',     name: 'EnergyCarbonPage',     meta: { requiresOrgContext: true }, component: () => import('@/pages/energy/carbon.vue') },
          { path: 'quality',    name: 'EnergyQualityPage',    meta: { requiresOrgContext: true }, component: () => import('@/pages/energy/quality.vue') },
          { path: 'meter',      name: 'EnergyMeterPage',      meta: { requiresOrgContext: true }, component: () => import('@/pages/energy/meter.vue') },
        ],
      },
      // 系统设置
      {
        path: 'settings',
        component: () => import('@/pages/console/RouteView.vue'),
        redirect: 'settings/users',
        children: [
          { path: 'users',         name: 'SettingsUsersPage',        component: () => import('@/pages/configCenterPage/userManage.vue') },
          { path: 'roles',         name: 'SettingsRolesPage',        component: () => import('@/pages/configCenterPage/roleManage.vue') },
          { path: 'orgs',          name: 'SettingsOrgsPage',         component: () => import('@/pages/configCenterPage/orgManage.vue') },

          { path: 'partners',      name: 'SettingsPartnersPage',     component: () => import('@/pages/configCenterPage/partManage.vue') },
          { path: 'apps',          name: 'SettingsAppsPage',         component: () => import('@/pages/configCenterPage/AppManage.vue') },

          { path: 'tags',          name: 'SettingsTagsPage',         component: () => import('@/pages/configCenterPage/tagManage.vue') },
          { path: 'alert-types',   name: 'SettingsAlertTypesPage',   component: () => import('@/pages/configCenterPage/riskManage.vue') },
          { path: 'push',          name: 'SettingsPushPage',         component: () => import('@/pages/configCenterPage/sendManange.vue') },
          { path: 'sms',           name: 'SettingsSmsPage',          component: () => import('@/pages/configCenterPage/noteManage.vue') },
          { path: 'voice',         name: 'SettingsVoicePage',        component: () => import('@/pages/configCenterPage/vmsManage.vue') },
          { path: 'hazard-config', name: 'SettingsHazardConfigPage', component: () => import('@/pages/configCenterPage/hiddenManage.vue') },
          { path: 'logs',          name: 'SettingsLogsPage',         component: () => import('@/pages/configCenterPage/logManage.vue') },
        ],
      },
      // 个人中心
      {
        path: 'profile',
        name: 'ProfilePage',
        component: () => import('@/pages/personalCenterPage/index.vue'),
      },
      {
        path: 'access-key',
        name: 'AccessKeyPage',
        component: () => import('@/pages/console/accessKey/index.vue'),
      },

    ],
  },
]
